import { Form, type FormItemProps } from "antd"
import React from "react"

import InputNumber from "../../../components/Input/InputNumber.tsx"

const PLANNED_MONEY_RULES: FormItemProps["rules"] = [
  { required: false },
  {
    type: "number",
    transform: (v) => (isNaN(+v) ? 0 : +v),
    min: 0,
    message: "Must be at least 0"
  }
]

export function PlannedMoneyInput(props: FormItemProps) {
  return (
    <Form.Item rules={PLANNED_MONEY_RULES} {...props}>
      <InputNumber
        min={0}
        max={999999999.99}
        step={0.1}
        precision={2}
        className="w-full"
        prefix="$"
        placeholder="00.00"
      />
    </Form.Item>
  )
}
